/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ durationDays: NonNullable<unknown>, productType: NonNullable<unknown> }} Trialsubscriptionconfirmdescription3Inputs */

const en_trialsubscriptionconfirmdescription3 = /** @type {(inputs: Trialsubscriptionconfirmdescription3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This will activate a ${i?.durationDays}-day ${i?.productType} trial for this business.`)
};

const de_trialsubscriptionconfirmdescription3 = /** @type {(inputs: Trialsubscriptionconfirmdescription3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dies aktiviert ein ${i?.durationDays}-tägiges ${i?.productType}-Testabo für dieses Unternehmen.`)
};

/**
* | output |
* | --- |
* | "This will activate a {durationDays}-day {productType} trial for this business." |
*
* @param {Trialsubscriptionconfirmdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const trialsubscriptionconfirmdescription3 = /** @type {((inputs: Trialsubscriptionconfirmdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trialsubscriptionconfirmdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_trialsubscriptionconfirmdescription3(inputs)
	return de_trialsubscriptionconfirmdescription3(inputs)
});
export { trialsubscriptionconfirmdescription3 as "trialSubscriptionConfirmDescription" }